/** Unscoped keys that mixed values across organizations. Removed, never read. */
export const LEGACY_ORG_LOCAL_KEYS = [
  'cube.segments.recentColumns',
  'cube.segments.autoCount',
  'cube.offerStudio.autoCount',
  'cube.offerReports.lastOffer',
];

export const ORG_LOCAL_SUFFIX = {
  recentColumns: 'cube.segments.recentColumns',
  segmentsAutoCount: 'cube.segments.autoCount',
  offerStudioAutoCount: 'cube.offerStudio.autoCount',
  lastOffer: 'cube.offerReports.lastOffer',
};

export function orgLocalKey(organizationId, suffix) {
  if (organizationId == null || organizationId === '') return null;
  return `${organizationId}.${suffix}`;
}

/** Drop the old unscoped keys. Their values can mix several organizations. */
export function purgeLegacyOrgLocalKeys() {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    for (const key of LEGACY_ORG_LOCAL_KEYS) {
      window.localStorage.removeItem(key);
    }
  } catch {
    /* ignore quota / private-mode failures */
  }
}

export function readOrgLocal(organizationId, suffix) {
  purgeLegacyOrgLocalKeys();
  const key = orgLocalKey(organizationId, suffix);
  if (!key || typeof window === 'undefined' || !window.localStorage) return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeOrgLocal(organizationId, suffix, value) {
  purgeLegacyOrgLocalKeys();
  const key = orgLocalKey(organizationId, suffix);
  if (!key || typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* ignore quota / private-mode failures */
  }
}

/** Boolean preference. Missing or unreadable values use `defaultValue`. */
export function readOrgFlag(organizationId, suffix, defaultValue = true) {
  const raw = readOrgLocal(organizationId, suffix);
  if (raw == null) return defaultValue;
  return raw === 'true';
}
